export var createGetSceneBackground = function (backgroundProviderMap) { return function (sceneId) {
    var provider = backgroundProviderMap.get(sceneId);
    if (provider) {
        return provider();
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/graphics/createGetSceneBackground.ts
// module id = 2183
// module chunks = 3